import { ValidationError } from "../dv/error/validation.error";
import { registerValidation } from "../dv/register.validation";

export function Min(value: number, message?: string) {
  return (target: any, key: string) => {
    registerValidation(target, key, (propValue: any) => {
      if (typeof propValue !== "number" || propValue < value) {
        throw new ValidationError(message || `Property "${key}" must be at least ${value}.`);
      }
    });
  };
}
